<ng-container [formGroup]="formGroup">
<div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox1_DI"
            >Average measured thickness, tam&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="aMeasuredThickness"
            (change)="onTamChange($event)"
            id="textBox1_DI"
            class="form-control form-control-sm"
            formControlName="textBox1_DI"
            min="0"
          />
        </div>
      </div>
      <!--------------------------------------------------------------------------------------------------------------------------------------------->
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox2_DI"
            >Minimum measured thickness, tmm&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="textBox2_DI"
            (change)="onTmmChange($event)"
            id="textBox2_DI"
            class="form-control form-control-sm"
            formControlName="textBox2_DI"
            min="0"
          />
        </div>
      </div>
      <!-------------------------------------------------------------------------------------------------------------->
      
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox7_DI_sngfcaML"
            >Future corrosion allowance inside the damage area, FCAml
            &nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="verticalDistanceFromTankFloor"
            (change)="onFcamlChange($event)"
            id="textBox7_DI_sngfcaML"
            class="form-control form-control-sm"
            formControlName="textBox7_DI_sngfcaML"
            min="0"
          />
        </div>
      </div>
      <!-------------------------------------------------------------------------------------------------------------->
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox3_DI_sngH_ml"
            >Axial distance from the lower edge of the metal loss area to the tank floor, H_ml&nbsp;<span *ngIf="this.intUnit === 0">(ft)</span
            ><span *ngIf="this.intUnit === 1">(m)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="text"
            name="verticalDistanceHml"
            (change)="onHmlChange($event)"
            id="textBox3_DI_sngH_ml"
            class="form-control form-control-sm"
            formControlName="textBox3_DI_sngH_ml"           
            autocomplete="off"
          />
            <!-- Remove Decimal Number validation -->
          <!-- (keypress)="utility_service.decimalFilter($event, 3)" -->
        </div>
      </div>
      
      <!-------------------------------------------------------------------------------------------------------------->
</ng-container>